// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2FF3k","rootSmall":"AddTileButton_rootSmall__Tp42X"};